import {Link} from "@tanstack/react-router";
import ArrowUpRightIcon from "../icons/ArrowUpRightIcon.tsx";

/**
 * Cross-sell band shown on every fixture generator, pointing to the full
 * tournament management software page.
 */
export default function TournamentManagementCta() {
    return (
        <section className="container mx-auto px-6 lg:px-12 pb-4">
            <div className="rounded-3xl border border-[#d9dce7] bg-white p-8 lg:p-12 text-center shadow-sm">
                <h2 className="font-bebas text-[#1a1a2e] uppercase text-[clamp(26px,3.5vw,40px)] font-bold tracking-wide mb-3">
                    Need more than a fixture generator?
                </h2>
                <p className="font-inter text-[#1a1a2e]/70 text-base max-w-2xl mx-auto mb-7">
                    ScorePal helps you manage registrations, live scores, standings, courts and player communication from one platform.
                </p>
                <div className="flex flex-wrap justify-center gap-3">
                    <Link
                        to={"/tournament-management-software/" as any}
                        className="inline-flex items-center gap-2 bg-[#082F8A] text-white rounded-full pl-6 pr-1 py-1 font-semibold hover:bg-[#06246b] transition"
                    >
                        <span className="font-inter text-base font-medium">Explore Tournament Management Software</span>
                        <div className="bg-white rounded-full p-1">
                            <ArrowUpRightIcon className="text-[#082F8A]" size={24} />
                        </div>
                    </Link>
                    <Link
                        to={"/contact/" as any}
                        className="rounded-full border border-[#d9dce7] px-6 py-3 font-inter font-semibold text-[#082F8A] hover:bg-[#EDEEF4] transition"
                    >
                        Get started - it's free
                    </Link>
                </div>
            </div>
        </section>
    );
}
